module.exports = __webpack_public_path__ + "statics/img/1-4.207c6b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product/icon/1-4.png
// module id = KMax
// module chunks = 1